<template>
  <v-container fluid class="pt-0">
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="5"
        class="pa-0 d-flex justify-center align-center flex-column"
        style="background-color: #161e3b; height: 80vh"
      >
        <v-spacer></v-spacer>
        <h3 class="white--text mb-0">
          <span>Licenciatura</span>

          en
        </h3>
        <h1 class="white--text text-center">{{ namecarrer }}</h1>
        <h4 class="mb-0" style="color: #ffffffb3">RVOE: 20232004</h4>
        <br />
        <router-link
          to="/informes"
          style="text-decoration: none; padding-bottom: 10px"
        >
          <v-btn rounded class="mt-5 mx-3" x-large>INFÓRMATE</v-btn>
        </router-link>
        <v-spacer></v-spacer>
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="7" class="pa-0">
        <v-img :src="renderMedia(picture)" height="80vh" width="100%"></v-img>
      </v-col>
    </v-row>
    <Information />
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="5"
        class="
          pa-sm-5 pa-md-8 pa-lg-12
          d-flex
          justify-center
          align-center
          flex-column
        "
        style="min-height: 50vh"
      >
        <h1 class="mt-12 mt-sm-12 mt-md-3 mb-0 text-left primary--text mb-6">
          Porque se trata de ti
        </h1>
        <h4 class="text-left font-weight-regular">
          {{ perfil_text }}
        </h4>
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="7" class="pa-sm-5 pa-md-8 pa-lg-12">
        <v-img
          contain
          :src="renderMedia(logo)"
          height="60vh"
          width="100%"
        ></v-img>
      </v-col>
    </v-row>
    <plan-for-redesign
      :logo="renderMedia(logo)"
      :btn_link="btn_link"
      :image="renderMedia(picture)"
      grado="de la licenciatura."
    />
    <v-row class="py-6">
      <v-col cols="12" sm="12" md="7">
        <h1 class="mb-5 mx-3 mx-sm-3 mx-md-5 mx-lg-8 primary--text">
          Perfil de egreso
        </h1>
        <ul
          :class="$vuetify.breakpoint.mdAndUp ? 'mt-5' : 'mt-5 px-2'"
          style="list-style-type: none"
        >
          <li
            v-for="(item, index) in egreso_list"
            :key="index"
            class="py-2 font-weight-regular"
            ALIGN="justify"
            :class="[$vuetify.breakpoint.xl ? 'title' : '']"
          >
            <span
              v-if="item.heading"
              ALIGN="justify"
              class="font-weight-bold font-italic"
              >{{ item.text }}</span
            >
            <span v-else>
              <i ALIGN="justify" class="mdi mdi-chevron-right"></i>
              {{ item.text }}
            </span>
          </li>
        </ul>
      </v-col>
      <v-divider
        class="ml-6"
        :vertical="$vuetify.breakpoint.mdAndUp"
      ></v-divider>
      <v-col cols="12" sm="12" md="4">
        <h1 class="mb-5 mx-3 mx-sm-3 mx-md-5 mx-lg-8 primary--text">
          Campo laboral
        </h1>
        <p class="mx-3 mx-sm-3 mx-md-5 mx-lg-8" v-for="item in text_action">
          {{ item.text }}
        </p>
      </v-col>
    </v-row>
    <FAQ :titlecol="12" :questionscol="12" />
  </v-container>
</template>
<style lang="scss" scoped>
.action-img {
  background-size: cover;
}
.action-img-mobile {
  background-size: cover;
  height: 400px;
}
.profile-img {
  background-size: cover;
}
.profile-img-mobile {
  background-size: contain;
  height: 200px;
}
.blue-bg {
  background-color: #111f3c;
}
</style>
<script>
import Information from "../components/Information.vue";
import { mapState, mapGetters } from "vuex";
import PlanForRedesign from "../components/PlanForRedesign";
import FAQ from "@/components/FAQ.vue";
import _ from "lodash";

export default {
  components: {
    Information,
    PlanForRedesign,
    FAQ,
  },
  computed: {
    ...mapState({
      offer: (state) => state.home.offer,
    }),
  },
  mounted() {
    if (this.offer.length > 1) {
      this.setData();
    }
  },
  data() {
    return {
      picture: "",
      btn_link: "",
      logo: "",
      publicPath: process.env.BASE_URL,
      text_action: [],
      text_ingreso: [],
      egreso_text: "",
      perfil_text: "",
      namecarrer: "",
      egreso_list: [],
      carreerDescription: "",
    };
  },
  methods: {
    renderMedia(image) {
      if (image.indexOf("https") < 0) {
        return "https://www.admin-uva.tidingo.com/" + image;
      } else {
        return image;
      }
    },
    setData() {
      var the_data = _.find(this.offer, { link: window.location.pathname });
      this.namecarrer = the_data.name;
      this.carreerDescription = the_data.carreerDescription;
      this.egreso_text = the_data.egreso_text;
      this.picture = the_data.picture;
      this.logo = the_data.logo;
      this.perfil_text = the_data.perfil_text;
      this.text_action = the_data.text_action;
      this.text_ingreso = the_data.text_ingreso;
      this.egreso_list = the_data.text_egreso;
    },
  },
  watch: {
    offer() {
      this.setData();
    },
  },
};
</script>